/*
  Dekogreen · reglas del buscador (28-09-2026).
  Funciones puras, sin DOM. Se prueban con `node --test "pruebas/*.test.cjs"`.
  En la tienda quedan en window.DKBuscador (las usan dk-buscador.js y dk-404.js).
*/
(function (raiz, fabrica) {
  if (typeof module === 'object' && module.exports) module.exports = fabrica();
  else raiz.DKBuscador = fabrica();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var VACIAS = ['de', 'del', 'la', 'las', 'el', 'los', 'para', 'con', 'y', 'e', 'en', 'a', 'al', 'un', 'una', 'unos', 'unas', 'por', 'mi', 'mis', 'tu', 'tus', 'que'];
  var GENERICAS_RUTA = ['products', 'collections', 'pages', 'blogs', 'artificial', 'artificiales', 'cm', 'uv', 'uds', 'caja'];

  function normalizar(texto) {
    return String(texto == null ? '' : texto)
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function palabras(texto) {
    var n = normalizar(texto);
    if (!n) return [];
    return n.split(' ').filter(function (p) { return p && VACIAS.indexOf(p) === -1; });
  }

  function tolerancia(palabra) {
    if (/^\d+$/.test(palabra) || palabra.length <= 3) return 0;
    return palabra.length <= 5 ? 1 : 2;
  }

  function distancia(a, b) {
    if (a === b) return 0;
    if (!a.length) return b.length;
    if (!b.length) return a.length;
    var fila = [];
    for (var j = 0; j <= b.length; j++) fila.push(j);
    for (var i = 1; i <= a.length; i++) {
      var diagonal = fila[0];
      fila[0] = i;
      for (var k = 1; k <= b.length; k++) {
        var arriba = fila[k];
        fila[k] = Math.min(arriba + 1, fila[k - 1] + 1, diagonal + (a.charAt(i - 1) === b.charAt(k - 1) ? 0 : 1));
        diagonal = arriba;
      }
    }
    return fila[b.length];
  }

  function comparar(q, p) {
    if (q === p) return 'exacta';
    if (q.length >= 4 && p.indexOf(q) === 0) return 'exacta';
    if (p.length >= 4 && q.indexOf(p) === 0) return 'exacta';
    var t = tolerancia(q);
    if (t && Math.abs(q.length - p.length) <= t && distancia(q, p) <= t) return 'aprox';
    return null;
  }

  function leerLineas(texto) {
    return String(texto || '').split(/\r?\n/)
      .map(function (l) { return l.trim(); })
      .filter(function (l) { return l && l.charAt(0) !== '#' && l.indexOf('=') > 0; })
      .map(function (l) {
        var i = l.indexOf('=');
        var pares = l.slice(0, i).split(',').map(function (c) {
          return { clave: palabras(c).join(' '), forma: c.trim().replace(/\s+/g, ' ').toLowerCase() };
        }).filter(function (x) { return x.clave; });
        return {
          claves: pares.map(function (x) { return x.clave; }),
          formas: pares.map(function (x) { return x.forma; }),
          valor: l.slice(i + 1).trim()
        };
      });
  }

  function leerMapa(texto) {
    return leerLineas(texto).map(function (l) { return { claves: l.claves, formas: l.formas, handle: l.valor }; });
  }

  function leerSinonimos(texto) {
    var frases = [], sueltas = {};
    leerLineas(texto).forEach(function (l) {
      var destinos = l.valor.split(',').map(function (v) { return palabras(v).join(' '); }).filter(Boolean);
      l.claves.forEach(function (c) {
        if (c.indexOf(' ') > -1) frases.push({ de: c, a: destinos[0] });
        else sueltas[c] = (sueltas[c] || []).concat(destinos.join(' ').split(' '));
      });
    });
    return { frases: frases, palabras: sueltas };
  }

  function grupos(consulta, sinonimos) {
    var s = sinonimos || { frases: [], palabras: {} };
    var texto = ' ' + palabras(consulta).join(' ') + ' ';
    s.frases.forEach(function (f) { texto = texto.split(' ' + f.de + ' ').join(' ' + f.a + ' '); });
    texto = texto.trim();
    if (!texto) return [];
    return texto.split(' ').map(function (p) { return [p].concat(s.palabras[p] || []); });
  }

  // Palabras de la ficha con su forma escrita (con tildes), para enseñar las correcciones bien escritas
  function palabrasConForma(texto) {
    return String(texto == null ? '' : texto).toLowerCase().split(/[^0-9a-z\u00c0-\u024f]+/)
      .map(function (o) { return { n: normalizar(o), o: o }; })
      .filter(function (w) { return w.n && w.n.indexOf(' ') === -1 && VACIAS.indexOf(w.n) === -1; });
  }

  function coincide(gs, texto) {
    var fichas = palabrasConForma(texto);
    var cambios = [];
    for (var g = 0; g < gs.length; g++) {
      var ultima = g === gs.length - 1;
      var encontrada = false, parecida = null;
      for (var x = 0; x < gs[g].length && !encontrada; x++) {
        for (var y = 0; y < fichas.length; y++) {
          // La última palabra se está escribiendo: cuenta como inicio de palabra desde la primera letra (como Shopify)
          var r = ultima && x === 0 && fichas[y].n.indexOf(gs[g][x]) === 0 ? 'exacta' : comparar(gs[g][x], fichas[y].n);
          if (r === 'exacta') { encontrada = true; break; }
          if (r === 'aprox' && !parecida) parecida = fichas[y].o;
        }
      }
      if (!encontrada && !parecida) return null;
      if (!encontrada) cambios.push({ desde: gs[g][0], a: parecida });
    }
    return { aprox: cambios.length > 0, cambios: cambios };
  }

  // Lo que escribió el cliente, con solo las palabras equivocadas cambiadas (conserva «de» y sus tildes)
  function corregirTexto(consulta, cambios) {
    return String(consulta).trim().replace(/\s+/g, ' ').split(' ').map(function (t) {
      var n = normalizar(t);
      for (var i = 0; i < cambios.length; i++) if (cambios[i].desde === n) return cambios[i].a;
      return t;
    }).join(' ');
  }

  function filtrar(productos, consulta, sinonimos) {
    var todos = productos.map(function (_, i) { return i; });
    if (normalizar(consulta).replace(/ /g, '').length < 3) return { visibles: todos, corregido: null, sinFiltro: true };
    var gs = grupos(consulta, sinonimos);
    if (!gs.length) return { visibles: todos, corregido: null, sinFiltro: true };
    var exactos = [], aproximados = [], correccion = null;
    productos.forEach(function (p, i) {
      var r = coincide(gs, p.texto);
      if (!r) return;
      if (r.aprox) { aproximados.push(i); if (!correccion) correccion = corregirTexto(consulta, r.cambios); }
      else exactos.push(i);
    });
    if (exactos.length) return { visibles: exactos, corregido: null, sinFiltro: false };
    if (aproximados.length) return { visibles: aproximados, corregido: correccion, sinFiltro: false };
    // Con la última palabra por debajo de 4 letras aún se está escribiendo: no se concluye «No encuentro»
    if (gs[gs.length - 1][0].length < 4) return { visibles: todos, corregido: null, sinFiltro: true };
    return { visibles: [], corregido: null, sinFiltro: false };
  }

  function fijar(consulta, mapa, sinonimos) {
    if (normalizar(consulta).replace(/ /g, '').length < 3) return null;
    var gs = grupos(consulta, sinonimos);
    if (!gs.length) return null;
    // Entre las claves que coinciden, gana la de longitud más parecida («jardín» no es «jardinera»)
    var exacto = null, menorDiferencia = Infinity, aproximado = null;
    for (var e = 0; e < mapa.length; e++) {
      for (var c = 0; c < mapa[e].claves.length; c++) {
        var clave = mapa[e].claves[c].split(' ');
        if (clave.length !== gs.length) continue;
        var tipo = 'exacta', diferencia = 0;
        for (var i = 0; i < gs.length && tipo; i++) {
          var mejor = null;
          for (var x = 0; x < gs[i].length; x++) {
            var r = comparar(gs[i][x], clave[i]);
            if (r === 'exacta') { mejor = 'exacta'; diferencia += Math.abs(gs[i][x].length - clave[i].length); break; }
            if (r === 'aprox') mejor = mejor || 'aprox';
          }
          if (!mejor) tipo = null;
          else if (mejor === 'aprox') tipo = 'aprox';
        }
        if (tipo === 'exacta' && diferencia < menorDiferencia) { exacto = { handle: mapa[e].handle, corregido: null }; menorDiferencia = diferencia; }
        if (tipo === 'aprox' && !aproximado) aproximado = { handle: mapa[e].handle, corregido: (mapa[e].formas || mapa[e].claves)[c] };
      }
    }
    return exacto || aproximado;
  }

  function sanear(termino) {
    var t = String(termino == null ? '' : termino).replace(/\s+/g, ' ').trim();
    if (/@/.test(t) || /\d{6,}/.test(t.replace(/[\s.\-]/g, ''))) return '';
    return t.slice(0, 60);
  }

  function desdeRuta(ruta, mapa) {
    var trozo = String(ruta || '').split('?')[0].split('/').filter(Boolean).pop() || '';
    try { trozo = decodeURIComponent(trozo); } catch (e) {}
    var dicho = palabras(trozo.replace(/[-_.]+/g, ' ')).filter(function (p) { return GENERICAS_RUTA.indexOf(p) === -1; });
    if (!dicho.length) return null;
    var candidatos = [dicho.join(' ')];
    for (var i = 0; i + 1 < dicho.length; i++) candidatos.push(dicho[i] + ' ' + dicho[i + 1]);
    candidatos = candidatos.concat(dicho);
    for (var k = 0; k < candidatos.length; k++) {
      var f = fijar(candidatos[k], mapa, null);
      if (f && !f.corregido) return { handle: f.handle, texto: dicho.join(' ') };
    }
    return null;
  }

  // Medición: cada búsqueda se apunta UNA vez, cuando el cliente termina. Mientras escribe solo se guarda
  // la última; se suelta tras «espera» ms sin cambios, o antes si toca, pulsa Intro o cierra. La misma
  // búsqueda dos veces seguidas (volver a abrir el buscador con lo mismo) se apunta una sola.
  function crearAnotador(enviar, espera) {
    var pendiente = null, reloj = null, ultimo = null;
    function parar() { if (reloj) { clearTimeout(reloj); reloj = null; } }
    function soltar() {
      parar();
      if (!pendiente) return;
      var datos = pendiente;
      pendiente = null;
      if (datos.termino === ultimo) return;
      ultimo = datos.termino;
      enviar(datos);
    }
    return {
      anotar: function (datos) { pendiente = datos; parar(); reloj = setTimeout(soltar, espera || 1500); },
      soltar: soltar,
      descartar: function () { parar(); pendiente = null; }
    };
  }

  return {
    normalizar: normalizar, palabras: palabras, tolerancia: tolerancia, distancia: distancia,
    comparar: comparar, leerMapa: leerMapa, leerSinonimos: leerSinonimos, grupos: grupos,
    coincide: coincide, filtrar: filtrar, fijar: fijar, sanear: sanear, desdeRuta: desdeRuta,
    crearAnotador: crearAnotador
  };
});
